import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
   AgentGreetingItem,
   AgentGreetingItemExpandedState,
   AgentGreetingSettingsState,
   AudioFileInfo,
} from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.state';

@Component({
   selector: 'samweb-agent-greeting-configuration-ici',
   templateUrl: './agent-greeting-configuration-ici.component.html',
   styleUrls: ['./agent-greeting-configuration-ici.component.scss'],
})
export class AgentGreetingConfigurationIciComponent implements OnInit {
   constructor(public store: Store) {}

   @Input()
   public skillId: number;

   @Input()
   public availableIci: string[];

   @Input()
   public searchValues: string[];

   @Input()
   public disabled = false;

   @Input()
   public draggedItemKey: AudioFileInfo;

   @Output()
   public waveFileDropped = new EventEmitter<AgentGreetingItem>();

   @Output()
   public removeAssignment = new EventEmitter<AgentGreetingItem>();

   @Output()
   public expandGroup = new EventEmitter<AgentGreetingItemExpandedState>();

   public isConfigConflicting$: Observable<boolean>;

   ngOnInit(): void {
      this.isConfigConflicting$ = this.store.select(AgentGreetingSettingsState.getSkillConfigIsConflicting(this.skillId));
   }

   drop(event: AgentGreetingItem) {
      this.waveFileDropped.emit(event);
   }

   remove(event: AgentGreetingItem) {
      this.removeAssignment.emit(event);
   }

   expandIciGroup(event: AgentGreetingItemExpandedState) {
      this.expandGroup.emit(event);
   }
}
